import { TdsButton } from '@scania/tegel-react'
import styled from 'styled-components'

export const RelativeDiv = styled.div`
  position: relative;
`

export const ImageDeleteButton = styled(TdsButton)`
  position: absolute;
  right: 0;
  top: 8px;
`

export const UserImage = styled.img`
  width: 100%;
`
export const UserFileItem = styled.div`
  width: 100%;
`

export const UserFileLinkRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  background-color: var(--tds-grey-100);
  border-bottom: 1px solid var(--tds-grey-400);
  align-items: center;
  padding-left: 8px;
  :first-child {
    border-top: 1px solid var(--tds-grey-400);
  }
`

export const UserFileLink = styled.a`
  padding: var(--tds-spacing-layout-16) 0;
`
